<template>
    <div>
        <div class="row text-center">
            <div class="col-sm-6 text-left align-self-center">{{ jobTitle.name }} {{ jobTitle.subName ? `(${jobTitle.subName})` : '' }}</div>
            <div class="col-sm-6 d-flex justify-content-end align-self-center">
                <button class="ds-btn mr-1" @click="showModal(jobTitle)" v-b-tooltip.hover title="Apskatīt/Rediģēt">
                    <font-awesome-icon icon="eye"/>
                </button>
                <button v-if="$route.name !== 'view-company-ovp-job-conditions'" class="ds-btn ds-btn--danger" @click="handleJobTitleRemoval" v-b-tooltip.hover title="Dzēst">
                    <font-awesome-icon icon="trash"/>
                </button>
            </div>
        </div>
        <hr class="my-2"/>
    </div>
</template>
<script>
    import {mapActions, mapMutations} from 'vuex';

    // import {JobTitle} from '../../vuex/modules/company/modules/job-titles/job-title.models';
    import * as jobTitleStoreTypes from '../../vuex/modules/company/modules/job-titles/job-title.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';

    export default {
        name: 'job-titles-list-item',
        props: {
            jobTitle: {
                type: Object,
                required: true,
            }
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyJobTitles: companyStoreTypes.SET_CURRENT_COMPANY_JOB_TITLES,
            }),
            ...mapActions('jobTitle', {
                /** @type {function|*} */
                removeJobTitle: jobTitleStoreTypes.ACTION_REMOVE_JOB_TITLE,
                 /** @type {function|*} */
                getJobTitles: jobTitleStoreTypes.ACTION_GET_JOB_TITLES,
                /** @type {function|*} */
                showModal: jobTitleStoreTypes.ACTION_SHOW_MODAL,
            }),
            async handleJobTitleRemoval() {
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Esi pārliecināts?', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    await this.removeJobTitle({companyId: this.$route.params.companyId, jobTitleId: this.jobTitle._id});
                
                    this.setAlertData({type: 'primary', message: 'Amats izdzēsts!'});
                    
                    const jobTitles = await this.getJobTitles({companyId: this.$route.params.companyId});
                    this.setCurrentCompanyJobTitles(jobTitles);
                } catch (err) {
                    //
                }
            },
        },
    }
</script>